import { DIETARY_FACTS, VITAMINERAL_FACTS, DIETARY_FACTS_OLD, VITAMINERAL_FACTS_OLD } from "./constants";

function addFact(preset) {
    return {
        nutrient: preset.nutrient ? { ...preset.nutrient } : "",
        quantity: "",
        uom: preset.uom ? { ...preset.uom } : "",
        pdv: {
            value: "",
            uom: { value: 191181, text: "%" },
        },
    };
}

export function newTemplate() {
    const dietary = DIETARY_FACTS.map((value) => {
        return addFact(value);
    });

    const vitamineral = VITAMINERAL_FACTS.map((value) => {
        return addFact(value);
    });

    return {
        header: "Nutrition Facts",
        template: "v2",
        dietary,
        vitamineral,
        footnotes: [],
        calorie: { caloriesFromFat: null, calories: "", servingText: "" },
    };
}

export function oldTemplate() {
    const dietary = DIETARY_FACTS_OLD.map((name) => {
        return addFact(name);
    });

    const vitamineral = VITAMINERAL_FACTS_OLD.map((name) => {
        return addFact(name);
    });

    return {
        header: "Nutrition Facts",
        template: "v1",
        dietary,
        vitamineral,
        footnotes: [],
        calorie: { caloriesFromFat: "", calories: "", servingText: "" },
    };
}

export function supplementTemplate() {
    const dietary = [];

    const vitamineral = [];

    return {
        dietary,
        vitamineral,
        footnotes: [],
        calorie: { caloriesFromFat: null, calories: "", servingText: "" },
    };
}
